import React from 'react';
import './DescriptionBox.css';

const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
      <div className="descriptionbox-navigator">
        <div className="descriptionbox-nav-box">
          Description
        </div>

        <div className="descriptionbox-nav-box fade">
          Reviews (122)
        </div>
      </div>

      <div className="descriptionbox-description">
        <p>
          An e-commerce website is an online platform where customers can
          browse and purchase products easily. This product is designed with
          high quality and provides a great shopping experience.
        </p>

        <p>
          Our products are carefully selected to provide customers with
          quality, style, and value. You can explore more products and find
          the perfect item for your needs.
        </p>
      </div>
    </div>
  );
};

export default DescriptionBox;